<template>
  <div class="row">
    <div class="col-md-6 user-password-profile">
      <div class="title">ГҮЙЛГЭЭНИЙ ПИН КОД СОЛИХ</div>
      <form
        action=""
        class="user-edit-panel-profile"
        @submit.prevent="changePinCode"
      >
        <div class="form-group">
          <label for="">ШИНЭ ПИН КОД:* </label>
          <div class="user-input">
            <input type="password" class="form-control" v-model="nPinCode" />
          </div>
        </div>
        <div class="form-group">
          <label for="">ШИНЭ ПИН КОД ДАВТАХ:* </label>
          <div class="user-input">
            <input type="password" class="form-control" v-model="rPinCode" />
          </div>
        </div>
        <div class="form-group">
          <label for="">УТАСНЫ ДУГААР:* </label>
          <div class="user-input">
            <input
              type="text"
              class="form-control"
              v-model="phoneNumber"
              disabled="true"
            />
          </div>
        </div>
        <div class="form-group">
          <label v-if="countDown > '0'" for=""
            >{{ countDown }} секундын дараа дахин код авна уу</label
          >
          <label v-if="countDown == '0' || countDown == ''" for=""></label>
          <div class="user-input">
            <input
              type="button"
              class="btn confirm-btn"
              value="Баталгаажуулах код авах"
              @click="getConfirmCode"
              :disabled="btnDisable"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="">БАТАЛГААЖУУЛАХ КОД ОРУУЛАХ:* </label>
          <div class="user-input">
            <input type="text" class="form-control" v-model="confirmCode" />
          </div>
        </div>
        <div class="form-group">
          <label for=""> </label>
          <div class="user-input">
            <input type="submit" class="btn user-btn" value="Хадгалах" />
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-6">
      <div class="reset-password-error">
        <div class="reset-password-error-inner" v-if="errorBox">
          <div class="password-error-icon">
            <img src="@/assets/icon/danger.png" alt="" />
          </div>
          <div class="password-error-msg">
            {{ errorBoxMessage }}
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
  </div>
</template>

<script>
import Error from "@/views/plugin/error";
import Success from "@/views/plugin/success";
import EventBus from "@/EventBus.js";
export default {
  props: ["phoneNumber"],
  data() {
    return {
      nPinCode: "",
      rPinCode: "",
      confirmCode: "",
      errorBox: false,
      errorBoxMessage: "",
      errorMessage: "",
      successMessage: "",
      errorModal: false,
      successModal: false,
      countDown: "",
      btnDisable: false,
    };
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else this.btnDisable = false;
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    getConfirmCode() {
      if (this.phoneNumber == "" || this.phoneNumber == "0") {
        this.errorMessage =
          "Хэрэглэгчийн мэдээлэл хэсэгт утасны дугаараа бүртгүүлнэ үү";
        this.errorModal = true;
        this.errorBoxMessage =
          "Анхааруулга : Таны үндсэн утасны дугаар өөрчлөгдсөн бол хэрэглэгчийн мэдээлэл засах хэсгээс утасны дугаараа өөрчилнө үү";
        this.errorBox = true;
      } else {
        this.btnDisable = true;
        this.countDown = 60;
        this.countDownTimer();
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        this.$bonusApi
          .post(`bonus-card/change/pin/otp`, {
            tokenId: tokenId,
            type: "ChangePinConfirmCode",
            typeValue: this.phoneNumber,
          },{
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          })
          .then((response) => {
            if (response.data === true) {
              this.successMessage = "Таны утасны дугаарт баталгаажуулах код илгээлээ!";
              this.successModal = true;
            } else if (response.data.status === 100) {
              this.errorBoxMessage = " ";
              this.errorBox = false;
              this.errorMessage = "Гүйлгээний пин код амжилттай солилоо";
              this.errorModal = true;
              this.$insProgress.finish();
            }
          })
          .catch((error) => {
           this.errorBoxMessage = " ";
                  this.errorBox = false;
                  this.errorMessage = response.data.message;
                  this.errorModal = true;
                  this.$insProgress.finish();
          });
      }
    },
    changePinCode() {
      if (this.confirmCode == "") {
        this.errorMessage = "Баталгаажуулах код заавал оруулна уу";
        this.errorModal = true;
        return;
      }
      var newPinCode = this.nPinCode;
      var rPinCode = this.rPinCode;
      if (newPinCode.length == 4) {
        if (newPinCode === rPinCode) {
          let isPinCode = /^[0-9]{4,4}$/.test(newPinCode);
          if (isPinCode) {
            var tokenId = localStorage.getItem("authToken");
            var user = this.$auth.getMe();
            if (tokenId == null || user == null) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
            var cardHolderInfId = user.cardHolderInfId;
            this.$bonusApi
              .post(`bonus-card/change/pincode`, {
                tokenId: tokenId,
                type: "ChangePinConfirmCode",
                typeValue: this.phoneNumber,
                pinCode: newPinCode,
                checkCode: this.confirmCode,
              }, {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          })
              .then((response) => {
                if (response.data.status === 1) {
                  this.nPinCode = "";
                  this.rPinCode = "";
                  this.confirmCode = "";
                  this.successMessage = response.data.message;
                  this.successModal = true;
                } else {
                  this.errorBoxMessage = " ";
                  this.errorBox = false;
                  this.errorMessage = response.data.message;
                  this.errorModal = true;
                  this.$insProgress.finish();
                }
              })
              .catch((error) => {
               this.errorBoxMessage = error.response.data.message;
                this.errorBox = true;
              });
          } else {
            this.errorBoxMessage =
              "Таны оруулсан пин код 4 оронтой, дан тооноос бүрдэх ёстой";
            this.errorBox = true;
          }
        } else {
          this.errorBoxMessage =
            "Таны оруулсан пин код хоорондоо ижил биш байна.";
          this.errorBox = true;
        }
      } else {
        this.errorBoxMessage = "Та 4 оронтой пин код оруулна уу.";
        this.errorBox = true;
      }
    },
  },
  components: {
    Error,
    Success,
  },
  created() {
    this.errorBoxMessage = "";
    this.errorBox = false;
  },
};
</script>

<style>
.user-password-profile {
  margin-top: 50px;
  padding-right: 3.5% !important;
}
.user-password-profile .title {
  font-size: 16px;
  width: 100%;
  color: #1660ab;
  font-weight: 500;
  text-align: right;
}
.user-password-profile .form-group .user-input {
  flex: 1 !important;
  justify-content: flex-end !important;
}
.user-password-profile .form-group .user-input input {
  width: 100% !important;
}
.user-password-profile .user-btn {
  height: 45px !important;
  border-radius: 5px !important;
  background-color: #1660ab !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 13px;
}
.user-password-profile .confirm-btn {
  height: 30px !important;
  border-radius: 5px !important;
  background-color: #1660ab !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 13px;
}
.reset-password-error {
  margin-top: 110px;
}
.reset-password-error-inner {
  width: 280px;
  height: 120px;
  border-radius: 5px;
  background-color: #fffafa;
  border: 1px solid #fad4ab;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding-top: 21px;
  padding-right: 30px;
  padding-bottom: 22px;
}
.reset-password-error-inner .password-error-icon {
  flex: 1;
  padding-left: 20px;
  color: #ed3237;
}
.reset-password-error-inner .password-error-msg {
  flex: 5;
  font-size: 11px;
  font-weight: 300;
  color: #000000;
}
.user-password-profile .form-group .user-input {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  border-radius: 2px;
}
.user-password-profile .form-group .user-input input {
  height: 30px;
  width: 100%;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.05);
}
</style>
